export enum AdminRoutePath {
  Home = '/',
  ModerationVacancies = '/moderation/vacancies',
  ModerationClientPatronage = '/moderation/client-patronage',
  ModerationsLegacyClients = '/moderations/clients/:id?',
  ModerationsLegacyCatalogItems = '/moderations/catalog/items/:id?',
  ServiceCaching = '/service/caching',
  Messages = '/messages/:dialogId?',
  ResponseDelay = '/metrics/response-delay',
  Specialists = '/clients/specialists/:id?',
  Employers = '/clients/employers/:id?',
  Vacancies = '/vacancies/:id?',
  Promocodes = '/promocodes',
  RoutesMeta = '/routes',
  RouteBlocks = '/routes/:routeId/blocks',
  Blocks = '/blocks',
  Subscriptions = '/subscriptions',
  Invoices = '/invoices',
  ThirdPartyApi = '/third-party-api',
  ProcessingAndReviews = '/processing-and-reviews',
}
